import React, { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiLock, FiTrash2, FiSearch, FiMessageSquare } = FiIcons;

export default function MessageModeration({ messages, onRemove, onClearAll }) {
  const [searchTerm, setSearchTerm] = useState('');

  // Filtrar mensajes por búsqueda
  const filteredMessages = messages.filter(msg =>
    msg.content.toLowerCase().includes(searchTerm.toLowerCase()) ||
    msg.nickname.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <section className="flex flex-col overflow-hidden rounded-2xl border border-white/10 bg-[#111] h-[550px]">
      <div className="border-b border-white/10 px-4 py-4 sm:px-6 shrink-0 flex flex-col sm:flex-row sm:items-center justify-between gap-3">
        <div>
          <h2 className="font-semibold text-white text-sm sm:text-base flex items-center gap-2">
            <SafeIcon icon={FiMessageSquare} className="text-red-500" />
            Mensajes Recientes
          </h2>
          <p className="mt-0.5 text-xs text-gray-500">
            Elimina o limpia mensajes inapropiados en tiempo real del chat general.
          </p>
        </div>
        {messages.length > 0 && (
          <button
            type="button"
            onClick={onClearAll}
            className="flex items-center gap-1.5 rounded-lg bg-red-500/10 px-3 py-2 text-[11px] font-medium text-red-400 hover:bg-red-500/20 transition-all shrink-0"
          >
            <SafeIcon icon={FiTrash2} size={14} />
            Limpiar Todo
          </button>
        )}
      </div>
      {/* Filtro de búsqueda */}
      <div className="px-4 py-2 bg-black/30 border-b border-white/5 shrink-0">
        <div className="flex items-center gap-2 rounded-lg bg-white/5 px-2.5 py-1.5">
          <SafeIcon icon={FiSearch} size={14} className="text-gray-500" />
          <input
            type="text"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            placeholder="Buscar por mensaje o apodo..."
            className="w-full bg-transparent text-xs text-white outline-none placeholder:text-gray-600"
          />
        </div>
      </div>
      {/* Lista con scroll elegante y visible */}
      <div className="flex-1 divide-y divide-white/5 overflow-y-auto">
        {filteredMessages.map((message) => (
          <article
            key={message.id}
            className="flex items-start gap-3 p-4 hover:bg-white/[0.01] transition-colors"
          >
            <div className="min-w-0 flex-1">
              <div className="mb-1 flex flex-wrap items-center gap-2">
                <strong className={`text-sm ${message.nickname.includes('ANUNCIO') ? 'text-red-500 font-bold' : 'text-white'}`}>
                  {message.nickname}
                </strong>
                {message.is_private && (
                  <span className="flex items-center gap-1 rounded bg-amber-500/10 px-1.5 py-0.5 text-[9px] text-amber-400">
                    <SafeIcon icon={FiLock} size={9} />
                    Privado
                  </span>
                )}
                <time className="text-[10px] text-gray-600">
                  {new Date(message.created_at).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                </time>
              </div>
              <p className="break-words text-sm text-gray-300">
                {message.content}
              </p>
            </div>
            <button
              type="button"
              onClick={() => onRemove(message)}
              aria-label="Ocultar mensaje"
              className="rounded-lg p-2 text-gray-500 hover:bg-red-500/10 hover:text-red-400 transition-colors shrink-0"
            >
              <SafeIcon icon={FiTrash2} size={16} />
            </button>
          </article>
        ))}
        {filteredMessages.length === 0 && (
          <div className="p-8 text-center text-sm text-gray-600">
            No se encontraron mensajes.
          </div>
        )}
      </div>
    </section>
  );
}